// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b0b140ed","321":"63dc006d","453":"016f414f","667":"80903ebf","668":"b25951e7"}[chunkId] + ".chunk.js";
};